jQuery(document).ready(function ($) {

    $('.mega-nav--custom').detach().appendTo('.services-nav');

    if ($(window).width() > 992) {
        $('.services-nav, .mega-nav, .menu-item-has-children').hover(
            function () {
                $('body').addClass('overlay-active');
            },
            function () {
                $('body').removeClass('overlay-active');
            }
        );

        /*-- Scroll Up/Down add class --*/
        let header = $('.header');
        let lastScrollTop = 0;
        $(window).scroll(function () {
            var st = $(this).scrollTop();
            lastScrollTop = st;
            if (st >= 200) {
                header.addClass('header--fixed');
            } else {
                header.removeClass('header--fixed');
            }
        });
    }

    if ($(window).width() < 993) {
        /* Toggle function for all menu-items with children (Services & default submenu's) */
        $('.mobile .services-nav, .mobile .menu-item-has-children').append('<div class="toggle-mega-nav"></div>');

        $('.mobile').on('click', '.toggle-mega-nav', function() {
            $(this).prev().addClass('show');
        });

        $('.mobile').on('click', '.mega-nav .close-nav', function() {
            $('.mega-nav').removeClass('show');
        });
    }

    if ($(window).width() < 480) {

        // Check if breadcrumb length is too long for mobile screens
        $(".breadcrumbs .current-item").each(function () {
            if ($(this).text().length > 50) {
                $(this).text($(this).text().substr(0, 50) + "...");
            }
        });
    }
});
